import { AxiosResponse } from "axios";
import instance from "./axiosInstance";
import { AvailableChartsResponse, MeasurementDataResponse, MeasurementRequest, SizeGuideRequest, SizeGuideResponse } from "../types/measurement-data/types";

export const submitSizeMeasurement = async (accessToken: string, data: MeasurementRequest): Promise<MeasurementDataResponse> => {
  try {
    const response: AxiosResponse<MeasurementDataResponse> = await instance.post(`/api/v1/services/bodyMeasurement`, data, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    });
    return response.data;
  } catch (error: any) {
    console.error("Error sending body measurement:", error);
    throw error;
  }
};

export const SizeGuide = async (accessToken: string, data: SizeGuideRequest): Promise<SizeGuideResponse> => {
  try {
    const response: AxiosResponse<SizeGuideResponse> = await instance.post(`/api/v1/services/size_guide`, data, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    });
    return response.data;
  } catch (error: any) {
    console.error("Error sending size guide request:", error);
    throw error;
  }
};

export const getAvailableCharts = async (accessToken: string): Promise<AvailableChartsResponse> => {
  try {
    const response: AxiosResponse<AvailableChartsResponse> = await instance.post(`/api/v1/services/available_charts`, null, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    });

    const allowedBrands = ["Canadagoose", "KitAndAce", "Knix", "Lululemon", "OakAndFort", "Patagonia", "Roots", "Vessi"];

    if (response.data.ok && response.data.data) {
      const filteredData: any = {};

      allowedBrands.forEach((brand) => {
        if (response.data.data[brand]) {
          filteredData[brand] = response.data.data[brand];
        }
      });

      return {
        ...response.data,
        data: filteredData,
      };
    }

    return response.data;
  } catch (error: any) {
    console.error("Error getting available charts:", error);
    throw error;
  }
};
